// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"950c0d2a","517":"ac447e2a","588":"95c0e578"}[chunkId] + ".chunk.js";
};